export default __webpack_public_path__ + "static/media/icon-in-network.c6548064.svg";